<script>
    export let to;

    import {Link} from "svelte-routing";
</script>


<span class="btn-floating halfway-fab waves-effect waves-light color-orange modal-trigger">
    <Link to="{to}">
        <i class="material-icons" title="More information">add</i>
    </Link>
</span>

<style>
    .color-orange {
        color: #004f9e;
        background-color: #004f9e;
    }
</style>